import Practice from "app/models/practice"
import { UserFunction } from "app/models/user"

export enum Types {
  GET = "PRACTICE_GET",
  GET_SUCCESS = "PRACTICE_GET_SUCCESS",
  GET_FAIL = "PRACTICE_GET_FAIL",
  PUT = "PRACTICE_PUT",
  PUT_SUCCESS = "PRACTICE_PUT_SUCCESS",
  PUT_FAIL = "PRACTICE_PUT_FAIL",
  PUT_FEATURES = "PRACTICE_FEATURES_PUT",
  PUT_FEATURES_SUCCESS = "PRACTICE_FEATURES_PUT_SUCCESS",
  PUT_FEATURES_FAIL = "PRACTICE_FEATURES_PUT_FAIL",
}

type PracticeProps = {
  field: string
  value: string | string[] | number | UserFunction | undefined
}

export type Action =
  | GetPracticeAction
  | GetPracticeSuccessAction
  | GetPracticeFailAction
  | PutPracticeAction
  | PutPracticeSuccessAction
  | PutPracticeFailAction
  | PutPracticeFeaturesAction
  | PutPracticeFeaturesSuccessAction
  | PutPracticeFeaturesFailAction

export type GetPracticeAction = {
  type: Types.GET
}

export type GetPracticeSuccessAction = {
  payload: { data: Practice | undefined }
  type: Types.GET_SUCCESS
}

export type GetPracticeFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PutPracticeAction = {
  type: Types.PUT
  payload: {
    data: PracticeProps
  }
}

export type PutPracticeSuccessAction = {
  type: Types.PUT_SUCCESS
}

export type PutPracticeFailAction = {
  type: Types.PUT_FAIL
  payload: { errors: object }
}

export type PutPracticeFeaturesAction = {
  type: Types.PUT_FEATURES
  payload: {
    data: Practice["features"]
  }
}

export type PutPracticeFeaturesSuccessAction = {
  payload: { data: Practice | undefined }
  type: Types.PUT_FEATURES_SUCCESS
}

export type PutPracticeFeaturesFailAction = {
  type: Types.PUT_FEATURES_FAIL
  payload: { errors: object }
}

export function getPractice(): GetPracticeAction {
  return {
    type: Types.GET,
  }
}

export function getPracticeSuccess(data: Practice | undefined): GetPracticeSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getPracticeFail(errors: object): GetPracticeFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function putPractice(data: PracticeProps): PutPracticeAction {
  return {
    payload: { data },
    type: Types.PUT,
  }
}

export function putPracticeSuccess(): PutPracticeSuccessAction {
  return {
    type: Types.PUT_SUCCESS,
  }
}

export function putPracticeFail(errors: object): PutPracticeFailAction {
  return {
    payload: { errors },
    type: Types.PUT_FAIL,
  }
}

export function putPracticeFeatures(data: Practice["features"]): PutPracticeFeaturesAction {
  return {
    payload: { data },
    type: Types.PUT_FEATURES,
  }
}

export function putPracticeFeaturesSuccess(data: Practice): PutPracticeFeaturesSuccessAction {
  return {
    type: Types.PUT_FEATURES_SUCCESS,
    payload: { data },
  }
}

export function putPracticeFeaturesFail(errors: object): PutPracticeFeaturesFailAction {
  return {
    payload: { errors },
    type: Types.PUT_FEATURES_FAIL,
  }
}
